module.exports = __webpack_public_path__ + "static/media/maui-skyline-finish@3x.7436b111.png";